import {
  Search, X, Tag,
  LeafyGreen, Droplets, HeartPulse, Cookie, Flame,
  Apple, Sprout, Milk, Snowflake, CupSoda, Beef, Croissant, SprayCan, ShoppingCart,
} from 'lucide-react';
import type { LucideProps } from 'lucide-react';
import type { ComponentType } from 'react';

const CATEGORY_ICONS: Record<string, ComponentType<LucideProps>> = {
  'verduleria': LeafyGreen,
  'pescaderia': Droplets,
  'Healty': HeartPulse,
  'Almacen': Cookie,
  'Condimentos': Flame,
  // Landing page categories
  'fruteria': Apple,
  'organicos': Sprout,
  'lacteos': Milk,
  'congelados': Snowflake,
  'bebidas': CupSoda,
  'carnes': Beef,
  'panaderia': Croissant,
  'limpieza': SprayCan,
};

export function CategoryIcon({ slug, ...props }: { slug: string } & LucideProps) {
  const Icon = CATEGORY_ICONS[slug] || Tag;
  return <Icon {...props} />;
}

export const DefaultCategoryIcon = ShoppingCart;

export { Search as SearchIcon, X as CloseIcon };
